import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { MatLegacyProgressSpinnerModule as MatProgressSpinnerModule } from '@angular/material/legacy-progress-spinner';
import { MatLegacyTooltipModule as MatTooltipModule } from '@angular/material/legacy-tooltip';
import { RouterModule } from '@angular/router';
import { PlaylistBreadcrumbItemComponent } from '@app/app/shared/breadcrumbs/component/playlist-breadcrumb/playlist-breadcrumb-item/playlist-breadcrumb-item.component';
import { PlaylistBreadcrumbComponent } from '@app/app/shared/breadcrumbs/component/playlist-breadcrumb/playlist-breadcrumbs.component';
import { TranslocoService } from '@ngneat/transloco';
import { NgxsModule } from '@ngxs/store';
import { CORE_PLAYLIST_DATA_SERVICE } from '../../page-modules/playlist/services/create/core/data.service';
import { TranslocoRootModule } from '../../transloco/transloco-root.module';
import { RestClientService } from '../services/rest-client.service';
import * as SharedFactoryService from '../shared-service-factory';
import { BreadcrumbsComponent } from './component/breadcrumbs.component';
import { BreadcrumbsState } from './store/breadcrumbs.state';

@NgModule({
  declarations: [BreadcrumbsComponent, PlaylistBreadcrumbComponent, PlaylistBreadcrumbItemComponent],
  imports: [
    CommonModule,
    RouterModule,
    TranslocoRootModule,
    NgxsModule.forFeature([BreadcrumbsState]),
    MatProgressSpinnerModule,
    MatTooltipModule,
  ],
  exports: [BreadcrumbsComponent, PlaylistBreadcrumbComponent, PlaylistBreadcrumbItemComponent],
  providers: [
    {
      provide: CORE_PLAYLIST_DATA_SERVICE,
      useFactory: SharedFactoryService.playlistServiceFactory,
      deps: [RestClientService, TranslocoService],
    },
  ],
})
export class BreadcrumbsModule {}
